export default state => next => action => {
    // if (action.type) {
    // 	console.log("%c Action: %c" + action.type, 'color: Blue; font-weight: bold;', 'color: Green; font-weight: bold;', action);
    // }
    return next(action);
  }